import angular from 'angular';

import PlanComponent from './plan.cmpt';
import ComponentModule from './component';

export default angular
    .module('common.plans.component.plan', [
        ComponentModule.name
    ])
    .component(PlanComponent.selector, PlanComponent);



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/index.js